import OutlinedInput from '@mui/material/OutlinedInput';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import {styled} from '@mui/material';

const StyledClearIcon = styled(ClearIcon)`
  cursor: pointer;
`;
const StyledSearch = styled(OutlinedInput)`
  background: white;
`;

const GlobalFilter = ({ globalFilter, setGlobalFilter, gotoPage }) => (
  <StyledSearch
    size="small"
    value={globalFilter || ''}
    margin="dense"
    onChange={e => {
      setGlobalFilter(e.target.value ? e.target.value.trimLeft() : undefined);
      if (gotoPage) gotoPage(0);
    }}
    placeholder="Filter ..."
    startAdornment={<SearchIcon />}
    endAdornment={
      <StyledClearIcon onClick={() => setGlobalFilter(undefined)} />
    }
    inputProps={{ 'aria-label': 'search' }}
  />
);

export default GlobalFilter;
